import Icona from 'components/3cat/ui/Icona';
import { useEffect, useState } from 'react';
import styles from './tornadalt.module.scss';

export default function TornaDalt() {
    const [showTopBtn, setShowTopBtn] = useState(false);
    const onHandleScroll = () => {
        if (window.scrollY > 400) {
            setShowTopBtn(true);
        } else {
            setShowTopBtn(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', onHandleScroll);

        return () => {
            window.removeEventListener('scroll', onHandleScroll);
        };
    }, []);
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        showTopBtn && (
            <button className={styles.torna} onClick={goToTop}>
                <Icona className={styles.icona} icona='fletxa_simple_amunt' isBlanc={false} inline={true} mida={30} />
            </button>
        )
    );
}
